import { render, staticRenderFns } from "./delete-person-modal.vue?vue&type=template&id=5f64ee6e&"
import script from "./delete-person-modal.vue?vue&type=script&lang=ts&"
export * from "./delete-person-modal.vue?vue&type=script&lang=ts&"
import style0 from "./delete-person-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports